import vhCheck       from 'vh-check';
import imagesLoaded  from 'imagesloaded';

import ScrollManager from './_managers/scroll';
import SvgAnimations from './_modules/svgAnimations';
import SplitLines    from './_modules/splitLines';
import LoopText      from './_modules/loopText';
import Slider        from './_modules/slider';
import MapBlock      from './_modules/map';
import Accordion     from './_modules/accordion';
import Video         from './_modules/video';
import Share         from './_modules/share';

import {isTouch, x0, x} from './_helpers';

const setup = () => {
    vhCheck();
    !isTouch && document.body.classList.add('no-touch');
    isTouch && document.body.classList.add('is-touch');
}

window.onload = () => {
    setup();

    if (window.innerWidth >= 900) {
        const splitLines    = new SplitLines();
    }

    const video         = new Video();
    const svgAnimations = new SvgAnimations();
    const loopText      = new LoopText();
    const map           = new MapBlock();
    const slider        = new Slider();
    const share         = new Share();
    const accordion     = new Accordion(el => {
        ScrollManager.update();
        map.update();
        slider.update();
        loopText.update();
    });

    //preload images
    const imgLoad = new imagesLoaded(x0('.body-site'));
    imgLoad.on('always', () => {
        setTimeout(() => {
            ScrollManager.init();
            x0('.page-is-loading').classList.remove('page-is-loading');
        }, 100);
    });
}
